$('.fancybox').fancybox();